import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IGetOrderOrPaymentDetail, IOrderOrPaymentDetail } from '../models/models'

export class GetOrderOrPaymentDetailApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/orderOrPaymentDetail',
      requesterInfo,
    })
  }

  public async getOrderOrPaymentDetail(request: IGetOrderOrPaymentDetail): Promise<IOrderOrPaymentDetail> {
    return await this.postAsync<IOrderOrPaymentDetail>(request)
  }
}
